import { render, staticRenderFns } from "./DeviceGroups.vue?vue&type=template&id=71e2a168&scoped=true"
import script from "./DeviceGroups.vue?vue&type=script&lang=ts"
export * from "./DeviceGroups.vue?vue&type=script&lang=ts"
import style0 from "./DeviceGroups.vue?vue&type=style&index=0&id=71e2a168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2a168",
  null
  
)

export default component.exports